export interface IItemMisc {
	code: number;
	name: string;
	itemType: string;
	miscItemType: string;
	itemGrade: string;
	craftAnimTrigger: string;
	stackable: number;
	initialCount: number;
	makeMaterial1: number;
	makeMaterial2: number;
}
